<div
  class="glass-container p-6 max-w-[1600px] mx-auto space-y-6 text-slate-800 dark:text-slate-200 animate-fade-in relative min-h-[85vh]">

  <!-- Decorative Backdrop Blobs for Glassmorphism highlights -->
  <div
    class="absolute top-10 left-1/4 w-80 h-80 bg-amber-400/10 dark:bg-amber-400/5 rounded-full blur-3xl -z-10 animate-pulse pointer-events-none"
    style="animation-duration: 8s;"></div>
  <div
    class="absolute bottom-20 right-1/4 w-96 h-96 bg-blue-400/10 dark:bg-blue-400/5 rounded-full blur-3xl -z-10 animate-pulse pointer-events-none"
    style="animation-duration: 12s;"></div>

  <!-- ================= Header Section ================= -->
  <div class="flex flex-col md:flex-row md:items-center justify-between gap-6 pb-2">
    <div class="space-y-1">
      <h1
        class="text-2xl md:text-3xl font-extrabold tracking-tight text-slate-900 dark:text-white flex items-center gap-3">
        <div
          class="w-10 h-10 rounded-2xl bg-amber-400/10 dark:bg-amber-400/20 flex items-center justify-center text-amber-500 shadow-[0_0_15px_rgba(251,191,36,0.3)]">
          <span class="material-icons">account_balance_wallet</span>
        </div>
        บัญชีเติมเงิน / รายการ Topup
      </h1>
      <p class="text-xs text-slate-500 dark:text-slate-400 font-medium pl-13">
        จัดการบัญชี เติมเงิน ปรับยอดธุรกรรม และตรวจสอบยอดเงินจอง (Hold) ของลูกค้า
      </p>
    </div>

    <!-- View Modes Tabs (Only show when not in detail view) -->
    <div class="segmented-tabs flex p-1 rounded-2xl backdrop-blur-md self-start shadow-sm border">
      <button (click)="switchViewMode('accounts')"
        [class]="viewMode === 'accounts' 
          ? 'px-5 py-2.5 bg-white dark:bg-slate-700 text-amber-600 dark:text-amber-400 rounded-xl shadow-md text-xs font-bold transition-all duration-300'
          : 'px-5 py-2.5 text-slate-500 hover:text-slate-900 dark:hover:text-white text-xs font-semibold transition-all duration-300 cursor-pointer'">
        บัญชีทั้งหมด
      </button>
      <button (click)="switchViewMode('transactions')"
        [class]="viewMode === 'transactions' 
          ? 'px-5 py-2.5 bg-white dark:bg-slate-700 text-amber-600 dark:text-amber-400 rounded-xl shadow-md text-xs font-bold transition-all duration-300'
          : 'px-5 py-2.5 text-slate-500 hover:text-slate-900 dark:hover:text-white text-xs font-semibold transition-all duration-300 cursor-pointer'">
        ธุรกรรมทั้งหมด
      </button>
    </div>
  </div>

  <!-- ================= VIEW 1: Accounts List ================= -->
  <div *ngIf="viewMode === 'accounts'" class="glass-panel rounded-3xl p-6 space-y-6 ">

    <!-- Table Control Bar -->
    <div class="flex flex-col sm:flex-row items-center justify-between gap-4">
      <!-- Search Field with Type Dropdown -->
      <div
        class="flex items-center w-full sm:max-w-md bg-white/80 dark:bg-slate-800/80 border border-slate-200/80 dark:border-slate-700/80 rounded-2xl px-4 py-2 focus-within:ring-4 focus-within:ring-amber-400/20 focus-within:border-amber-400 transition-all duration-300 shadow-inner">
        <span class="material-icons text-slate-400 mr-3 text-xl">search</span>
        <input type="text" [(ngModel)]="searchText" (ngModelChange)="onSearchChange()"
          placeholder="ค้นหาเลขบัญชี ชื่อผู้ใช้ เบอร์โทร..."
          class="w-full text-sm outline-none border-none bg-transparent text-slate-700 dark:text-slate-200" />

        <!-- Search Type Dropdown -->
        <div class="relative border-l border-slate-200/80 dark:border-slate-700/80 pl-3 ml-3">
          <button (click)="toggleSearchTypeDropdown()"
            class="flex items-center gap-1.5 text-xs font-bold text-slate-600 dark:text-slate-400 hover:text-amber-500 cursor-pointer transition-colors">
            <span>{{ currentSearchTypeLabel }}</span>
            <span class="material-icons text-xs text-slate-400 transition-transform"
              [class.rotate-180]="isSearchTypeDropdownOpen">arrow_drop_down</span>
          </button>

          <div *ngIf="isSearchTypeDropdownOpen" (mousedown)="$event.preventDefault()"
            class="absolute right-0 mt-3.5 z-50 w-36 bg-white/95 dark:bg-slate-800/95 backdrop-blur-md border border-slate-100 dark:border-slate-700/50 rounded-2xl shadow-xl py-1.5 animate-fade-in">
            <button (click)="selectSearchType('all')"
              class="w-full text-left px-4 py-2 text-xs text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 block transition-colors cursor-pointer">ทั้งหมด</button>
            <button (click)="selectSearchType('topupnumber')"
              class="w-full text-left px-4 py-2 text-xs text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 block transition-colors cursor-pointer">เลขบัญชี</button>
            <button (click)="selectSearchType('fullname')"
              class="w-full text-left px-4 py-2 text-xs text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 block transition-colors cursor-pointer">ชื่อผู้ใช้</button>
            <button (click)="selectSearchType('phone')"
              class="w-full text-left px-4 py-2 text-xs text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 block transition-colors cursor-pointer">เบอร์โทร</button>
          </div>
        </div>
      </div>

      <!-- Action buttons -->
      <button (click)="loadAccounts()"
        class="group flex items-center gap-2 px-5 py-2.5 bg-white dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700/80 hover:bg-slate-50 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 font-bold rounded-2xl text-xs shadow-sm cursor-pointer transition-all duration-300 hover:scale-102 hover:shadow-amber-500/10">
        <span class="material-icons text-sm transition-transform duration-500 group-hover:rotate-180">refresh</span>
        รีเฟรช
      </button>
    </div>

    <!-- Table main container -->
    <div
      class="overflow-x-auto border border-slate-200/50 dark:border-slate-700/50 rounded-2xl custom-scrollbar shadow-sm bg-white/40 dark:bg-slate-900/10">
      <table class="premium-table text-left text-sm">
        <thead>
          <tr
            class="bg-slate-50/60 dark:bg-slate-800/40 text-slate-500 dark:text-slate-400 font-bold text-xs uppercase tracking-wider">
            <th class="py-4 px-5 cursor-pointer hover:bg-slate-100/50 dark:hover:bg-slate-800/50 rounded-tl-2xl"
              (click)="sortData('topupNumber')">
              เลขบัญชี Topup
              <span *ngIf="sortColumn === 'topupNumber'" class="material-icons text-xs align-middle ml-1">
                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
              </span>
            </th>
            <th class="py-4 px-5 cursor-pointer hover:bg-slate-100/50 dark:hover:bg-slate-800/50"
              (click)="sortData('fullName')">
              ชื่อผู้ใช้
              <span *ngIf="sortColumn === 'fullName'" class="material-icons text-xs align-middle ml-1">
                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
              </span>
            </th>
            <th class="py-4 px-5 cursor-pointer hover:bg-slate-100/50 dark:hover:bg-slate-800/50"
              (click)="sortData('phone')">
              เบอร์โทร
              <span *ngIf="sortColumn === 'phone'" class="material-icons text-xs align-middle ml-1">
                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
              </span>
            </th>
            <th class="py-4 px-5 cursor-pointer hover:bg-slate-100/50 dark:hover:bg-slate-800/50 text-right"
              (click)="sortData('amount')">
              ยอดเงินคงเหลือ
              <span *ngIf="sortColumn === 'amount'" class="material-icons text-xs align-middle ml-1">
                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
              </span>
            </th>
            <th class="py-4 px-5 cursor-pointer hover:bg-slate-100/50 dark:hover:bg-slate-800/50 text-center"
              (click)="sortData('createDate')">
              วันที่สร้างบัญชี
              <span *ngIf="sortColumn === 'createDate'" class="material-icons text-xs align-middle ml-1">
                {{ sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
              </span>
            </th>
            <th class="py-4 px-5 text-center">สิทธิ์ปรับยอด</th>
            <th class="py-4 px-5 text-center rounded-tr-2xl">จัดการ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-100/80 dark:divide-slate-800/80">
          <tr *ngFor="let item of accounts" (click)="viewAccountDetail(item.id)"
            class="bg-white  hover:bg-slate-200/40 dark:hover:bg-slate-800/60 dark:bg-slate-800/40 cursor-pointer transition-all duration-300 animate-row-fade">
            <td class="py-4 px-5 font-extrabold text-slate-900 dark:text-slate-100">{{ item.topupNumber }}</td>
            <td class="py-4 px-5 font-semibold text-slate-700 dark:text-slate-300">{{ item.fullName }}</td>
            <td class="py-4 px-5 text-slate-500 dark:text-slate-400 font-medium">{{ item.phone }}</td>
            <td class="py-4 px-5 text-right font-black text-amber-600 dark:text-amber-400 text-base">{{ item.amount |
              number:'1.2-2' }} บาท</td>
            <td class="py-4 px-5 text-center text-slate-400 dark:text-slate-500 text-xs font-semibold">{{
              item.createDate | date:'dd/MM/yyyy HH:mm' }}</td>
            <td class="py-4 px-5 text-center">
              <span
                [class]="item.canAdjustBalance 
                ? 'px-3 py-1 rounded-xl text-[10px] font-bold bg-green-50 dark:bg-green-950/30 text-green-600 dark:text-green-400 border border-green-200/50 dark:border-green-800/50' 
                : 'px-3 py-1 rounded-xl text-[10px] font-bold bg-slate-50 dark:bg-slate-800/50 text-slate-400 dark:text-slate-500 border border-slate-200/50 dark:border-slate-700/50'">
                {{ item.canAdjustBalance ? 'อนุญาต' : 'ปิดใช้งาน' }}
              </span>
            </td>
            <td class="py-4 px-5 text-center" (click)="$event.stopPropagation()">
              <button (click)="viewAccountDetail(item.id)"
                class="group text-amber-500 hover:text-amber-600 dark:hover:text-amber-400 font-bold text-xs flex items-center justify-center gap-1.5 mx-auto cursor-pointer transition-all duration-300">
                <span class="material-icons text-sm">visibility</span>
                <span>ดูรายละเอียด</span>
                <span
                  class="material-icons text-[10px] opacity-0 -ml-3 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300">arrow_forward</span>
              </button>
            </td>
          </tr>
          <tr *ngIf="accounts.length === 0">
            <td colspan="7" class="py-16 text-center">
              <div
                class="flex flex-col items-center justify-center p-6 border-2 border-dashed border-slate-200/60 dark:border-slate-700/60 rounded-3xl bg-slate-50/30 dark:bg-slate-800/20 max-w-md mx-auto">
                <div
                  class="w-16 h-16 bg-slate-100 dark:bg-slate-800 rounded-full flex items-center justify-center mb-4 shadow-inner">
                  <span
                    class="material-icons text-4xl text-slate-300 dark:text-slate-600 animate-bounce">search_off</span>
                </div>
                <h3 class="text-sm font-extrabold text-slate-700 dark:text-slate-300 mb-1">ไม่พบข้อมูลบัญชี Topup</h3>
                <p class="text-xs text-slate-500 dark:text-slate-400 font-medium">ลองเปลี่ยนคำค้นหา
                  หรือรีเฟรชข้อมูลใหม่อีกครั้ง</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Standard Pagination Footer -->
    <div class="flex flex-col sm:flex-row items-center justify-between gap-4 mt-6">
      <!-- Left: Item Range Info & Page Size Selection -->
      <div class="flex items-center gap-3">
        <span class="text-xs font-bold text-slate-500 dark:text-slate-400">
          แสดง {{ startItemIndex }} - {{ endItemIndex }} จาก {{ totalItems }} รายการ
        </span>

        <!-- Page Size Selection Dropdown -->
        <div class="relative">
          <button (click)="togglePageSizeDropdown()" (blur)="closePageSizeDropdown()"
            class="flex items-center gap-1.5 px-3 py-1.5 bg-white dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700/80 rounded-xl text-xs font-bold text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 focus:outline-none focus:ring-1 focus:ring-amber-400 cursor-pointer transition-all shadow-sm">
            <span>{{ pageSize }} / หน้า</span>
            <span class="material-icons text-slate-400 text-sm transition-transform duration-200"
              [class.rotate-180]="isPageSizeDropdownOpen">expand_more</span>
          </button>

          <div *ngIf="isPageSizeDropdownOpen" (mousedown)="$event.preventDefault()"
            class="absolute bottom-full left-0 mb-2 z-50 min-w-[5rem] bg-white/95 dark:bg-slate-800/95 backdrop-blur-md border border-slate-100 dark:border-slate-700 rounded-xl shadow-lg py-1 animate-fade-in text-center">
            <button *ngFor="let opt of pageSizeOptions" (click)="selectPageSize(opt)"
              class="w-full text-center px-3 py-2 text-xs font-bold text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 block transition-colors cursor-pointer">
              {{ opt }} / หน้า
            </button>
          </div>
        </div>
      </div>

      <!-- Right: Pagination Buttons -->
      <div class="flex items-center gap-1.5">
        <!-- Prev Page -->
        <button (click)="setPage(currentPage - 1)" [disabled]="currentPage === 1"
          class="w-8 h-8 rounded-xl border border-slate-200/60 dark:border-slate-700/60 bg-white dark:bg-slate-800 text-slate-400 disabled:opacity-40 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors flex items-center justify-center cursor-pointer">
          <span class="material-icons text-sm">chevron_left</span>
        </button>

        <!-- Numbered Pages -->
        <ng-container *ngFor="let page of pagesArray">
          <!-- Active Page -->
          <button *ngIf="page === currentPage"
            class="w-8 h-8 rounded-xl bg-amber-400 text-slate-900 font-black shadow-[0_4px_14px_rgba(251,191,36,0.4)] flex items-center justify-center text-xs">
            {{ page }}
          </button>

          <!-- Inactive Page -->
          <button *ngIf="page !== currentPage" (click)="setPage(page)"
            class="w-8 h-8 rounded-xl text-slate-600 dark:text-slate-300 font-bold hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 transition-all flex items-center justify-center text-xs cursor-pointer">
            {{ page }}
          </button>
        </ng-container>

        <!-- Next Page -->
        <button (click)="setPage(currentPage + 1)" [disabled]="currentPage === totalPages"
          class="w-8 h-8 rounded-xl border border-slate-200/60 dark:border-slate-700/60 bg-white dark:bg-slate-800 text-slate-400 disabled:opacity-40 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors flex items-center justify-center cursor-pointer">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>

  </div>

  <!-- ================= VIEW 2: Global Transactions List ================= -->
  <div *ngIf="viewMode === 'transactions'" class="glass-panel rounded-3xl p-6 space-y-6">

    <!-- Table Control Bar -->
    <div class="flex flex-col md:flex-row items-center justify-between gap-4">
      <div class="flex flex-wrap items-center gap-3 w-full md:w-auto">
        <!-- Date Filter Inputs (using Material Datepicker) -->
        <div
          class="flex items-center gap-2 bg-white/80 dark:bg-slate-800/80 border border-slate-200/80 dark:border-slate-700/80 rounded-2xl px-4 py-2 shadow-sm text-xs font-bold text-slate-700 dark:text-slate-300">
          <span class="material-icons text-slate-400 text-base">calendar_today</span>

          <mat-form-field class="custom-mat-datepicker-input w-24">
            <input matInput [matDatepicker]="globalStartPicker" [(ngModel)]="txStartDate"
              (dateChange)="onTxSearchChange()">
            <mat-datepicker #globalStartPicker panelClass="modern-yellow-datepicker"></mat-datepicker>
          </mat-form-field>
          <button (click)="globalStartPicker.open()"
            class="text-slate-600 dark:text-slate-300 hover:text-amber-500 dark:hover:text-amber-400 cursor-pointer transition-colors">
            {{ txStartDate | date:'dd/MM/yyyy' }}
          </button>

          <span class="text-slate-400 font-bold px-1.5">ถึง</span>

          <mat-form-field class="custom-mat-datepicker-input w-24">
            <input matInput [matDatepicker]="globalEndPicker" [min]="txStartDate" [(ngModel)]="txEndDate"
              (dateChange)="onTxSearchChange()">
            <mat-datepicker #globalEndPicker panelClass="modern-yellow-datepicker"></mat-datepicker>
          </mat-form-field>
          <button (click)="globalEndPicker.open()"
            class="text-slate-600 dark:text-slate-300 hover:text-amber-500 dark:hover:text-amber-400 cursor-pointer transition-colors">
            {{ txEndDate | date:'dd/MM/yyyy' }}
          </button>
        </div>

        <!-- Search input -->
        <div
          class="flex items-center bg-white/80 dark:bg-slate-800/80 border border-slate-200/80 dark:border-slate-700/80 rounded-2xl px-4 py-2 focus-within:ring-4 focus-within:ring-amber-400/20 focus-within:border-amber-400 transition-all duration-300 shadow-sm text-xs w-full sm:max-w-xs">
          <input type="text" [(ngModel)]="txSearchText" (ngModelChange)="onTxSearchChange()"
            placeholder="ค้นหาเลขบัญชี ชื่อผู้ใช้ เบอร์โทร..."
            class="w-full outline-none border-none bg-transparent text-slate-700 dark:text-slate-200" />

          <!-- Dropdown search option -->
          <div class="relative border-l border-slate-200/80 dark:border-slate-700/80 pl-3 ml-3">
            <button (click)="toggleTxSearchDropdown()"
              class="flex items-center gap-1.5 font-extrabold text-slate-600 dark:text-slate-400 hover:text-amber-500 cursor-pointer transition-colors">
              <span>{{ currentTxSearchTypeLabel }}</span>
              <span class="material-icons text-xs text-slate-400 transition-transform"
                [class.rotate-180]="isTxSearchDropdownOpen">arrow_drop_down</span>
            </button>

            <div *ngIf="isTxSearchDropdownOpen" (mousedown)="$event.preventDefault()"
              class="absolute right-0 mt-3.5 z-50 w-32 bg-white/95 dark:bg-slate-800/95 backdrop-blur-md border border-slate-100 dark:border-slate-700/50 rounded-2xl shadow-lg py-1.5 animate-fade-in">
              <button (click)="selectTxSearchType('all')"
                class="w-full text-left px-4 py-2 text-xs text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 block transition-colors cursor-pointer">ทั้งหมด</button>
              <button (click)="selectTxSearchType('topupnumber')"
                class="w-full text-left px-4 py-2 text-xs text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 block transition-colors cursor-pointer">เลขบัญชี</button>
              <button (click)="selectTxSearchType('fullname')"
                class="w-full text-left px-4 py-2 text-xs text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 block transition-colors cursor-pointer">ชื่อผู้ใช้</button>
              <button (click)="selectTxSearchType('phone')"
                class="w-full text-left px-4 py-2 text-xs text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 block transition-colors cursor-pointer">เบอร์โทร</button>
            </div>
          </div>
        </div>

        <!-- Filter Toggle -->
        <button (click)="showTableFilters = !showTableFilters"
          [class]="showTableFilters 
            ? 'flex items-center gap-1.5 px-4 py-2 border border-amber-300 bg-amber-500/10 text-amber-600 dark:text-amber-400 font-bold rounded-2xl text-xs shadow-sm cursor-pointer hover:bg-amber-500/20 transition-all duration-300'
            : 'flex items-center gap-1.5 px-4 py-2 bg-white dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700/80 hover:bg-slate-50 dark:hover:bg-slate-700 text-slate-650 dark:text-slate-350 font-bold rounded-2xl text-xs shadow-sm cursor-pointer transition-all duration-300 hover:scale-102'">
          <span class="material-icons text-sm">filter_list</span>
          กรองขั้นสูง
        </button>
      </div>

      <button (click)="loadGlobalTransactions()"
        class="group flex items-center gap-2 px-5 py-2.5 bg-white dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700/80 hover:bg-slate-50 dark:hover:bg-slate-700 text-slate-700 dark:text-slate-300 font-bold rounded-2xl text-xs shadow-sm cursor-pointer transition-all duration-300 hover:scale-102 self-end md:self-auto hover:shadow-amber-500/10">
        <span class="material-icons text-sm transition-transform duration-500 group-hover:rotate-180">refresh</span>
        รีเฟรช
      </button>
    </div>

    <!-- Advanced Filter Panel (Horizontal Collapsible) -->
    <div *ngIf="showTableFilters"
      class="grid grid-cols-1 sm:grid-cols-3 gap-5 p-5 bg-white/60 dark:bg-slate-800/60 border border-slate-200/50 dark:border-slate-700/50 rounded-2xl shadow-inner animate-fade-in">

      <!-- Topup Method Filter -->
      <div class="space-y-2">
        <label
          class="text-xs font-extrabold text-slate-500 dark:text-slate-400 uppercase tracking-wide">ประเภทธุรกรรม</label>
        <div
          class="relative bg-white dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700/80 rounded-2xl px-4 py-2.5 shadow-sm focus-within:ring-2 focus-within:ring-amber-400">
          <button (click)="toggleMethodFilterDropdown()" (blur)="closeMethodFilterDropdown()"
            class="w-full flex items-center justify-between bg-transparent border-none text-xs font-semibold text-slate-700 dark:text-slate-300 outline-none cursor-pointer">
            <span>{{ methodFilterLabel }}</span>
            <span class="material-icons text-slate-400 text-sm transition-transform duration-200"
              [class.rotate-180]="isMethodFilterDropdownOpen">expand_more</span>
          </button>

          <div *ngIf="isMethodFilterDropdownOpen" (mousedown)="$event.preventDefault()"
            class="absolute top-full left-0 mt-2 z-50 w-full bg-white/95 dark:bg-slate-800/95 backdrop-blur-md border border-slate-100 dark:border-slate-700 rounded-xl shadow-lg py-1 animate-fade-in text-left">
            <button (click)="selectMethodFilter(null)"
              class="w-full text-left px-4 py-2 text-xs font-semibold text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 transition-colors cursor-pointer block">
              ทั้งหมด
            </button>
            <button (click)="selectMethodFilter(1)"
              class="w-full text-left px-4 py-2 text-xs font-semibold text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 transition-colors cursor-pointer block">
              เติมเงิน (Top Up)
            </button>
            <button (click)="selectMethodFilter(2)"
              class="w-full text-left px-4 py-2 text-xs font-semibold text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 transition-colors cursor-pointer block">
              ชำระด้วยยอด Topup
            </button>
            <button (click)="selectMethodFilter(3)"
              class="w-full text-left px-4 py-2 text-xs font-semibold text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 transition-colors cursor-pointer block">
              ปรับยอดเพิ่ม (Backoffice)
            </button>
            <button (click)="selectMethodFilter(4)"
              class="w-full text-left px-4 py-2 text-xs font-semibold text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 transition-colors cursor-pointer block">
              ปรับยอดลด (Backoffice)
            </button>
          </div>
        </div>
      </div>

      <!-- Min Amount Filter -->
      <div class="space-y-2">
        <label
          class="text-xs font-extrabold text-slate-500 dark:text-slate-400 uppercase tracking-wide">ยอดเงินขั้นต่ำ</label>
        <div
          class="flex items-center bg-white dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700/80 rounded-2xl px-4 py-2.5 shadow-sm focus-within:ring-2 focus-within:ring-amber-400">
          <input type="number" [(ngModel)]="txMinAmount" (ngModelChange)="onTxSearchChange()"
            placeholder="ระบุจำนวนเงินต่ำสุด..."
            class="w-full bg-transparent border-none text-xs font-semibold outline-none text-slate-700 dark:text-slate-300" />
          <span class="text-[10px] text-slate-450 dark:text-slate-500 font-extrabold">บาท</span>
        </div>
      </div>

      <!-- Max Amount Filter -->
      <div class="space-y-2">
        <label
          class="text-xs font-extrabold text-slate-500 dark:text-slate-400 uppercase tracking-wide">ยอดเงินสูงสุด</label>
        <div
          class="flex items-center bg-white dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700/80 rounded-2xl px-4 py-2.5 shadow-sm focus-within:ring-2 focus-within:ring-amber-400">
          <input type="number" [(ngModel)]="txMaxAmount" (ngModelChange)="onTxSearchChange()"
            placeholder="ระบุจำนวนเงินสูงสุด..."
            class="w-full bg-transparent border-none text-xs font-semibold outline-none text-slate-700 dark:text-slate-300" />
          <span class="text-[10px] text-slate-450 dark:text-slate-500 font-extrabold">บาท</span>
        </div>
      </div>

    </div>

    <!-- Table Main Container -->
    <div
      class="overflow-x-auto border border-slate-200/50 dark:border-slate-700/50 rounded-2xl custom-scrollbar shadow-sm bg-white/40 dark:bg-slate-900/10">
      <table class="premium-table text-left text-sm">
        <thead>
          <tr
            class="bg-slate-50/60 dark:bg-slate-800/40 text-slate-500 dark:text-slate-400 font-bold text-xs uppercase tracking-wider">
            <th class="py-4 px-5 rounded-tl-2xl">เลขธุรกรรม / วันที่</th>
            <th class="py-4 px-5">เลขบัญชี Topup</th>
            <th class="py-4 px-5">ชื่อผู้ใช้ / เบอร์โทร</th>
            <th class="py-4 px-5">ประเภทธุรกรรม</th>
            <th class="py-4 px-5 text-right">จำนวนเงิน</th>
            <th class="py-4 px-5 text-right">ยอดเงินคงเหลือ</th>
            <th class="py-4 px-5 text-center">สถานะ</th>
            <th class="py-4 px-5 rounded-tr-2xl">หมายเหตุ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-100/80 dark:divide-slate-800/80">
          <tr *ngFor="let item of globalTransactions"
            class="hover:bg-white/80 dark:hover:bg-slate-800/60 transition-colors animate-row-fade">
            <td class="py-4 px-5">
              <div class="font-extrabold text-slate-900 dark:text-slate-100 text-xs">{{ item.transactionNo || '-' }}
              </div>
              <div class="text-[10px] text-slate-400 dark:text-slate-500 font-bold mt-1">{{ item.paidDate |
                date:'dd/MM/yyyy HH:mm' }}</div>
            </td>
            <td class="py-4 px-5 font-bold text-slate-600 dark:text-slate-400 text-xs">{{ item.topupNumber }}</td>
            <td class="py-4 px-5">
              <div class="font-semibold text-xs text-slate-700 dark:text-slate-300">{{ item.fullName }}</div>
              <div class="text-[10px] text-slate-400 dark:text-slate-500 mt-0.5">{{ item.phone }}</div>
            </td>
            <td class="py-4 px-5 text-xs font-semibold">
              <span [class]="
                item.topupMethod === 1 ? 'text-blue-600 dark:text-blue-400' :
                item.topupMethod === 2 ? 'text-slate-550 dark:text-slate-400' :
                item.topupMethod === 3 ? 'text-green-600 dark:text-green-400' : 'text-rose-500 dark:text-rose-450'">
                {{ item.description }}
              </span>
              <span *ngIf="item.feeName" class="text-[10px] font-medium text-slate-400 block mt-0.5">({{ item.feeName
                }})</span>
            </td>
            <td class="py-4 px-5 text-right font-black text-sm"
              [class.text-green-600]="item.topupMethod === 1 || item.topupMethod === 3"
              [class.text-rose-500]="item.topupMethod === 2 || item.topupMethod === 4">
              {{ (item.topupMethod === 1 || item.topupMethod === 3 ? '+' : '-') }} {{ item.amount | number:'1.2-2' }}
            </td>
            <td class="py-4 px-5 text-right font-bold text-slate-700 dark:text-slate-300 text-xs">
              {{ item.balance != null ? (item.balance | number:'1.2-2') + ' บาท' : '-' }}
            </td>
            <td class="py-4 px-5 text-center">
              <span
                [class]="item.isPendingApproval 
                ? 'px-2.5 py-1 rounded-xl text-[10px] font-bold bg-amber-50 dark:bg-amber-950/30 text-amber-600 dark:text-amber-400 border border-amber-200/50 dark:border-amber-900/50' 
                : 'px-2.5 py-1 rounded-xl text-[10px] font-bold bg-green-50 dark:bg-green-950/30 text-green-600 dark:text-green-400 border border-green-200/50 dark:border-green-800/50'">
                {{ item.isPendingApproval ? 'รออนุมัติ' : 'สำเร็จ' }}
              </span>
            </td>
            <td class="py-4 px-5 text-xs text-slate-500 dark:text-slate-400 max-w-[200px] truncate"
              [title]="item.remark">{{ item.remark || '-' }}</td>
          </tr>
          <tr *ngIf="globalTransactions.length === 0">
            <td colspan="8" class="py-16 text-center">
              <div
                class="flex flex-col items-center justify-center p-6 border-2 border-dashed border-slate-200/60 dark:border-slate-700/60 rounded-3xl bg-slate-50/30 dark:bg-slate-800/20 max-w-md mx-auto">
                <div
                  class="w-16 h-16 bg-slate-100 dark:bg-slate-800 rounded-full flex items-center justify-center mb-4 shadow-inner">
                  <span
                    class="material-icons text-4xl text-slate-300 dark:text-slate-600 animate-bounce">search_off</span>
                </div>
                <h3 class="text-sm font-extrabold text-slate-700 dark:text-slate-300 mb-1">ไม่พบประวัติรายการธุรกรรม
                </h3>
                <p class="text-xs text-slate-500 dark:text-slate-400 font-medium">ในช่วงเวลาที่กำหนด
                  หรือลองเปลี่ยนตัวกรองค้นหา</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Standard Pagination Footer -->
    <div class="flex flex-col sm:flex-row items-center justify-between gap-4 mt-6">
      <!-- Left: Item Range Info & Page Size Selection -->
      <div class="flex items-center gap-3">
        <span class="text-xs font-bold text-slate-500 dark:text-slate-400">
          แสดง {{ txStartItemIndex }} - {{ txEndItemIndex }} จาก {{ txTotalItems }} รายการ
        </span>

        <!-- Page Size Selection Dropdown -->
        <div class="relative">
          <button (click)="toggleTxPageSizeDropdown()" (blur)="closeTxPageSizeDropdown()"
            class="flex items-center gap-1.5 px-3 py-1.5 bg-white dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700/80 rounded-xl text-xs font-bold text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 focus:outline-none focus:ring-1 focus:ring-amber-400 cursor-pointer transition-all shadow-sm">
            <span>{{ txPageSize }} / หน้า</span>
            <span class="material-icons text-slate-400 text-sm transition-transform duration-200"
              [class.rotate-180]="isTxPageSizeDropdownOpen">expand_more</span>
          </button>

          <div *ngIf="isTxPageSizeDropdownOpen" (mousedown)="$event.preventDefault()"
            class="absolute bottom-full left-0 mb-2 z-50 min-w-[5rem] bg-white/95 dark:bg-slate-800/95 backdrop-blur-md border border-slate-100 dark:border-slate-700 rounded-xl shadow-lg py-1 animate-fade-in text-center">
            <button *ngFor="let opt of pageSizeOptions" (click)="selectTxPageSize(opt)"
              class="w-full text-center px-3 py-2 text-xs font-bold text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 block transition-colors cursor-pointer">
              {{ opt }} / หน้า
            </button>
          </div>
        </div>
      </div>

      <!-- Right: Pagination Buttons -->
      <div class="flex items-center gap-1.5">
        <!-- Prev Page -->
        <button (click)="setTxPage(txCurrentPage - 1)" [disabled]="txCurrentPage === 1"
          class="w-8 h-8 rounded-xl border border-slate-200/60 dark:border-slate-700/60 bg-white dark:bg-slate-800 text-slate-400 disabled:opacity-40 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors flex items-center justify-center cursor-pointer">
          <span class="material-icons text-sm">chevron_left</span>
        </button>

        <!-- Numbered Pages -->
        <ng-container *ngFor="let page of txPagesArray">
          <!-- Active Page -->
          <button *ngIf="page === txCurrentPage"
            class="w-8 h-8 rounded-xl bg-amber-400 text-slate-900 font-black shadow-[0_4px_14px_rgba(251,191,36,0.4)] flex items-center justify-center text-xs">
            {{ page }}
          </button>

          <!-- Inactive Page -->
          <button *ngIf="page !== txCurrentPage" (click)="setTxPage(page)"
            class="w-8 h-8 rounded-xl text-slate-600 dark:text-slate-300 font-bold hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 transition-all flex items-center justify-center text-xs cursor-pointer">
            {{ page }}
          </button>
        </ng-container>

        <!-- Next Page -->
        <button (click)="setTxPage(txCurrentPage + 1)" [disabled]="txCurrentPage === txTotalPages"
          class="w-8 h-8 rounded-xl border border-slate-200/60 dark:border-slate-700/60 bg-white dark:bg-slate-800 text-slate-400 disabled:opacity-40 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors flex items-center justify-center cursor-pointer">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>

  </div>



</div>
<!-- ================= MODAL COMPONENT: Account Detail Modal ================= -->
<app-modal-topup-detail *ngIf="isDetailModalOpen && selectedAccountId" [accountId]="selectedAccountId" [userId]="userId"
  [menuId]="menuId" (close)="isDetailModalOpen = false" (saveSuccess)="onDetailSaveSuccess()">
</app-modal-topup-detail>
<!-- ================= SHARED COMPONENT: Loading Overlay ================= -->
<!-- CRITICAL: Place app-pss-loading outside the outermost main div wrapper to display properly as a fullscreen overlay -->
<app-pss-loading *ngIf="isLoading"></app-pss-loading>